import { useSyncExternalStore } from "react";

/** Phone / small-tablet width: below Tailwind's `md` (768 px). The three-pane mail layout becomes one pane at a time. */
const QUERY = "(max-width: 767px)";

export function useNarrow(): boolean {
    return useSyncExternalStore(
        (cb) => {
            const mq = window.matchMedia(QUERY);
            mq.addEventListener("change", cb);
            return () => mq.removeEventListener("change", cb);
        },
        () => window.matchMedia(QUERY).matches,
        () => false
    );
}
